<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
  <div id="device-popup" class="ol-popup">
    <div id="popup-content" v-if="showpopup">
      <v-card tile flat>
        <v-card-title class="px-0 pt-0 text-body-1 font-weight-bold">
          <v-container>
            <v-row>
              <v-col v-if="!changeTitleCheck" class="pa-0" :cols="10">
                <div>{{ deviceName || deviceSerialNumberComplete }}</div>
                <div v-if="deviceName" class="text-body-2 font-weight-regular">
                  {{ deviceSerialNumberComplete }}
                </div>
              </v-col>
              <v-col v-else class="pa-0" :cols="10">
                <v-text-field v-model="deviceNameInput" dense></v-text-field>
              </v-col>
              <v-col class="pa-0 text-right" :cols="2">
                <v-btn icon small @click="closePopup">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-title>

        <v-card-subtitle class="px-0 pb-0">
          <span>
            <span class="font-weight-medium">
              {{ language.t("DevicePopup.status") }}:
            </span>
            <v-chip small :color="getStatusColor()">{{ deviceStatus }}</v-chip>
          </span>
          <br />
          <v-btn v-if="!popupExpanded" x-small plain @click="popupExpanded = true">...</v-btn>
          <span v-if="popupExpanded">
            <span class="font-weight-medium">
              {{ language.t("DevicePopup.lastUpdate") }}:
            </span>
            <br />
            {{ lastUpdate }}
            <br />
          </span>
          <span v-if="popupExpanded">
            <span class="font-weight-medium">
              {{ language.t("DevicePopup.lastVersion") }}:
            </span>
            <br />
            {{ lastVersion }}
            <br />
          </span>
          <span v-if="popupExpanded && deviceProductionLoaded">
            <span class="font-weight-medium">
              {{ language.t("DevicePopup.hours") }}{{
      getDeviceType() == 'RBP' ?
        " " + language.t("DevicePopup.steeringlines") :
        "" }}:
              <br />
            </span>
            <v-simple-table dense>
              <thead>
                <tr>
                  <th class="text-left">
                    {{ language.t("DevicePopup.total") }}
                  </th>
                  <th class="text-left">
                    {{ language.t("DevicePopup.ytd") }}
                  </th>
                  <th class="text-left">
                    {{ language.t("DevicePopup.lastYear") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ totalHours.total }}</td>
                  <td>{{ totalHours.ytd }}</td>
                  <td>{{ totalHours.lastYear }}</td>
                </tr>
              </tbody>
            </v-simple-table>
            <br />
          </span>
          <span v-if="popupExpanded && deviceProductionLoaded && getDeviceType() == 'RBP'">
            <span class="font-weight-medium">
              {{ this.$selectedUnitSystem == "me" ? language.t("DevicePopup.km") : language.t("DevicePopup.miles")  }}:
              <br />
            </span>
            <v-simple-table dense>
              <thead>
                <tr>
                  <th class="text-left">
                    {{ language.t("DevicePopup.total") }}
                  </th>
                  <th class="text-left">
                    {{ language.t("DevicePopup.ytd") }}
                  </th>
                  <th class="text-left">
                    {{ language.t("DevicePopup.lastYear") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td> {{ totalKM.total }}</td>
                  <td>{{ totalKM.ytd }}</td>
                  <td>{{ totalKM.lastYear }}</td>
                </tr>
              </tbody>
            </v-simple-table>
            <br />
          </span>
        </v-card-subtitle>
        <v-card-actions v-if="popupExpanded">
          <v-btn small v-if="!changeTitleCheck" icon @click="editTitle">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn small v-if="changeTitleCheck" icon @click="editTitle">
            <v-icon>mdi-pencil-off</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn small v-if="changeTitleCheck" icon @click="saveTitle" :loading="loading">
            <v-icon>mdi-check</v-icon>
          </v-btn>

          <v-btn small v-if="!changeTitleCheck" icon @click="popupExpanded = false">
            <v-icon>mdi-chevron-up</v-icon>
          </v-btn>

        </v-card-actions>
      </v-card>
      <!-- <p style="margin-bottom: 0px; font-size: small">
      <b style="font-size: medium">
        {{ deviceName }}
        <v-icon small @click="editTitle">mdi-pencil</v-icon></b
      ><br />Status: {{ deviceStatus }}
      
    </p> -->
    </div>
  </div>
</template>
<script>
import moment from "moment/min/moment-with-locales";
import { containsCoordinate } from "ol/extent";

export default {
  data: () => ({
    showpopup: false,
    popupExpanded: false,
    loading: false,
    accountId: null,
    deviceNameInput: "",
    deviceName: "",
    deviceStatus: "",
    lastUpdate: "" || null,
    lastVersion: "",
    changeTitleCheck: false,
    latest_activity: null,
    deviceSerialNumberComplete: null,

    deviceProductionLoaded: false,
    totalHours: {
      total: 0,
      ytd: 0,
      lastYear: 0
    },
    totalKM: {
      total: 0,
      ytd: 0,
      lastYear: 0
    }
  }),
  watch: {
    "language.locale"() {
      if (this.latest_activity) this.lastUpdate = moment(this.latest_activity.timestamp).add(moment().utcOffset(), 'm').locale(this.language.locale).fromNow();
    },
  },
  methods: {
    editTitle() {
      this.changeTitleCheck = !this.changeTitleCheck;
    },
    getStatusColor() {
      if (this.deviceStatus) return this.deviceStatus === "online" ? "green" : "gray";

      return "gray";
    },
    saveTitle() {
      this.loading = true;

      let data = new FormData();
      data.set("designator", this.deviceNameInput);

      this.$axios
        .post(route("api.devices.edit", this.accountId), data, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then(() => {
          this.$axios.get(route("api.devices.single", this.accountId)).then((res) => {
            this.deviceName = res.data.designator || "";
            this.loading = false;
            this.deviceNameInput = this.deviceName;
            this.changeTitleCheck = !this.changeTitleCheck;
          });
        });
    },
    closePopup() {
      this.popupExpanded = false;
      this.showpopup = false;
      this.changeTitleCheck = false;
      this.$emit("closePopup");
    },
    setDeviceData(deviceData) {

      console.log(deviceData)
      this.showpopup = true;
      this.lastVersion = deviceData.deviceSoftwareVersion;
      this.accountId = deviceData.accountId;
      this.deviceName = deviceData.designator || "";
      this.deviceStatus = deviceData.latest_activity.online ? "online" : "offline";
      this.latest_activity = deviceData.latest_activity;
      this.deviceSerialNumberComplete = deviceData.deviceSerialNumberComplete;

      this.lastUpdate = moment(this.latest_activity.timestamp).add(moment().utcOffset(), 'm').locale(this.language.locale).fromNow();

      this.deviceNameInput = this.deviceName;

      this.getProductionData()
    },
    getProductionData() {
      this.deviceProductionLoaded = false;
      this.$axios.get(route("api.devices.production", this.accountId)).then((res) => {
        console.log(res);

        this.totalHours.total = (res.data.total.totalSeconds / 3600).toFixed(2);
        this.totalHours.ytd = (res.data.ytd.totalSeconds / 3600).toFixed(2);
        this.totalHours.lastYear = (res.data.lastYear.totalSeconds / 3600).toFixed(2);

        if (this.$selectedUnitSystem == "me") {
          this.totalKM.total = (res.data.total.totalMeters / 1000).toFixed(2);
          this.totalKM.ytd = (res.data.ytd.totalMeters / 1000).toFixed(2);
          this.totalKM.lastYear = (res.data.lastYear.totalMeters / 1000).toFixed(2);
        } else {
          this.totalKM.total = (res.data.total.totalMeters * 0.000621371192).toFixed(2);
          this.totalKM.ytd = (res.data.ytd.totalMeters * 0.000621371192).toFixed(2);
          this.totalKM.lastYear = (res.data.lastYear.totalMeters * 0.000621371192).toFixed(2);
        }
        this.deviceProductionLoaded = true;
      })
    },
    getDeviceType() {
      return this.deviceSerialNumberComplete.substring(0, 3);
    }
  },
};
</script>
<style>
.ol-popup {
  position: absolute;
  background-color: white;
  -webkit-filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));
  filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));
  padding: 15px;
  border-radius: 10px;
  border: 1px solid #cccccc;
  bottom: 12px;
  left: -50px;
  min-width: 280px;
}

.ol-popup:after,
.ol-popup:before {
  top: 100%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.ol-popup:after {
  border-top-color: white;
  border-width: 10px;
  left: 48px;
  margin-left: -10px;
}

.ol-popup:before {
  border-top-color: #cccccc;
  border-width: 11px;
  left: 48px;
  margin-left: -11px;
}

.ol-popup-closer {
  text-decoration: none;
  position: absolute;
  top: 2px;
  right: 8px;
}

.ol-popup-closer:after {
  content: "x";
}
</style>
<style scoped>
tr:hover {
  background-color: transparent !important;
}
</style>